import { Provider } from 'react-redux';  
import configureStore from './store/index.js';  
import DPAppLayout from './DPAppLayout';

const store = configureStore();
function DPApplayoutWrapper(props) {  
    return (  
        <Provider store={store}>  
            <DPAppLayout {...props} />  
        </Provider>  
    );  
}  

export default DPApplayoutWrapper; 